import React from "react";
import { Form } from "react-bootstrap";
import { useAppContext } from "../AppContext";
import useAxiosFetch from "../common/useAxiosFetch";
import { useTranslation } from "react-i18next";

const ProjectForm = ({handleSubmit, onSubmit, register, text}) => {
  const { t } = useTranslation();
  const { currentOrg, currentUser } = useAppContext();
  const { data: users, loading: userLoading } = useAxiosFetch("/api/users/");
  const { data: orgs, loading: orgLoading } = useAxiosFetch("/api/organizations/");

  if(userLoading || orgLoading)
    return <div>Loading...</div>;

  return (

    <form onSubmit={handleSubmit(onSubmit)}>
      <Form.Group className="mb-3">
        <Form.Label>{t('domain')} {t('name').toLowerCase()}</Form.Label>
        <Form.Control {...register("name")} as="input" name="name" required />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>{t('organization')}</Form.Label>
        <Form.Select {...register("orgId")}  name="orgId" defaultValue={currentOrg.id} >
          {
          orgs.map((org) => {
            return (
              <option key={org["id"]} value={org["id"]}>
                {org.name}
              </option>
            );
          })}
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>{t('domain')} {t('owner_without_prefix').toLowerCase()}</Form.Label>
        <Form.Select {...register("ownerUserId")}  name="ownerUserId" defaultValue={currentUser.user_id} >
          {
          // filter out users with role='user'
          users.filter((user) => user.role !== 'user').map((user) => {
            return (
              <option key={user["id"]} value={user["id"]}>
                {user.name}
              </option>
            );
          })}

        </Form.Select>
      </Form.Group>

      <div className="vertical-spacer" />

      <input className="white-border-btn submit-btn" type="submit" value={text} />

    </form>
  );
};

export default ProjectForm;
